import React from "react";
import { colors } from "@teamrota/rota-design";

import {
  StyledMemberName,
  StyledIssue,
  StyledHighlight,
  StyledEmph
} from "../styles";

export const WorkingHoursLimit = ({ memberName, children, member }) => (
  <>
    <StyledMemberName>
      The member <br></br> "{memberName}" has reached their working hours limit.
    </StyledMemberName>
    <StyledIssue style={{ border: "none" }}>
      {children}
      <StyledHighlight style={{ color: colors.red }}>
        Limited to {member.limitedHours ?? 0} hours / week
      </StyledHighlight>
    </StyledIssue>
  </>
);

export const QualifiedAndUnavailable = ({ memberName, children }) => (
  <>
    <StyledMemberName>{memberName}</StyledMemberName>
    <StyledIssue style={{ paddingBottom: "24px" }}>{children}</StyledIssue>
  </>
);

export const Conflicted = ({ memberName, conflictTimes, member }) => (
  <>
    <StyledMemberName>
      The member <br></br>"{memberName}" has a conflict.
    </StyledMemberName>
    <StyledIssue>
      <StyledEmph>
        By overriding, {member.firstName}'s will be booked on to two different
        shifts at the same time:
      </StyledEmph>
      <StyledHighlight style={{ color: colors.red }}>
        {conflictTimes}
      </StyledHighlight>
    </StyledIssue>
  </>
);
